import { Colors } from 'libs/ui/theme';

import { SvgIcon } from '../SvgIcon';
import { SvgProps } from '../types';

interface AlertTriangleProps extends SvgProps {
  glyphColor?: Colors | string;
}

export const AlertTriangle = ({
  size = 16,
  color = Colors.black,
  glyphColor = Colors.white,
  className,
}: AlertTriangleProps) => (
  <SvgIcon className={className} size={size}>
    <svg
      color={color}
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.7 2.25C7.28 1.25 8.72 1.25 9.3 2.25L14.8 11.75C15.38 12.75 14.66 14 13.5 14H2.5C1.34 14 0.62 12.75 1.2 11.75L6.7 2.25Z"
        fill="currentColor"
      />
      <path
        d="M8 5.75V9"
        stroke={glyphColor}
        strokeLinecap="round"
        strokeWidth="1.5"
      />
      <circle cx="8" cy="11.5" fill={glyphColor} r="0.85" />
    </svg>
  </SvgIcon>
);
